import React from 'react';

import './suffix-wrapper.scss';

/**
 * Describe component here
 * @param props
 */
const SuffixWrapper = ({ ...props }) => {

  return <div className={'suffix-wrapper flex items-center justify-center my-[6px] mr-[6px] ml-0'}>
    <svg width={'24px'} height={'24px'}>{props.children}</svg>
  </div>;
};

export default SuffixWrapper;
